import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReorderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reorder"}/>
}
